import { defineComponent as d, ref as c, createBlock as m, openBlock as t, resolveDynamicComponent as p, normalizeClass as u, unref as i, withCtx as f, renderSlot as v, createElementBlock as g, createCommentVNode as C, createElementVNode as n, Fragment as E, createVNode as b } from "vue";
import { GuideIcon as h } from "@scalar-org/guide-icons";
import { EditorClasses as k } from "../../../../styles.js";
const I = /* @__PURE__ */ d({
  __name: "ScalarHeading",
  props: {
    id: {},
    isEditable: { type: Boolean },
    level: {}
  },
  setup(r) {
    const l = r, a = c(!1);
    function s() {
      var e;
      console.log(l.isEditable, l.id), !l.isEditable && ((e = document.getElementById(l.id)) == null || e.scrollIntoView(!0), navigator.clipboard.writeText(`${window.location.href}#${l.id}`), a.value = !0, setTimeout(() => {
        a.value = !1;
      }, 1200));
    }
    return (e, o) => (t(), m(p(`h${Number.parseInt(e.level, 10) + 1}`), {
      id: e.id,
      class: u(["scroll-pad interaction-observer-heading", [i(k).Heading, a.value && "show-copied"]]),
      "data-level": e.level,
      "data-scalar-type": "heading"
    }, {
      default: f(() => [
        v(e.$slots, "default", {}, () => [
          o[0] || (o[0] = n("ssg-children", null, null, -1))
        ]),
        !e.isEditable && e.level <= 2 ? (t(), g(E, { key: 0 }, [
          o[1] || (o[1] = n("span", { class: "notify" }, "Copied!", -1)),
          b(i(h), {
            class: "icon",
            src: "solid/mail-sign-hashtag",
            onClick: s
          })
        ], 64)) : C("", !0)
      ]),
      _: 3
    }, 8, ["id", "class", "data-level"]));
  }
});
export {
  I as default
};
